import { authFetch, headers } from '../_helpers';

export const refereeService = {
  userLookup,
  addToLeaderboard,
  createUser,
  myEvents,
  myPastEvents,
  timesRecorded,
  deleteTimeRecorded,
};

async function userLookup(userName) {
  const res = await authFetch(
    '/api/Referee/UserLookup',
    headers.postPrimitive(userName),
  );
  return res;
}

async function addToLeaderboard(result) {
  const res = await authFetch(
    '/api/Referee/AddToLeaderboard',
    headers.post(result),
  );
  return res;
}

async function createUser(result) {
  const res = await authFetch('/api/Referee/CreateUser', headers.post(result));
  return res;
}

async function myEvents() {
  const res = await authFetch('/api/Referee/MyEvents', headers.get());
  return res;
}

async function myPastEvents() {
  const res = await authFetch('/api/Referee/MyPastEvents', headers.get());
  return res;
}

/**
 *
 * @param {Number} eventId
 */
async function timesRecorded(eventId) {
  const res = await authFetch(
    `/api/Referee/TimesRecorded/${eventId}`,
    headers.get(),
  );
  return res;
}

async function deleteTimeRecorded(id) {
  const res = await authFetch(
    `/api/Referee/DeleteTimeRecorded/${id}`,
    headers._delete(),
  );
  return res;
}
